<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('pcgc')"
                        :other-button="appointmentObj"
                        @openAppointmentModal="openAppointmentModal"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('pcgc')"
                              :other-button="appointmentObj"
                              @openAppointmentModal="openAppointmentModal"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col md="4">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input v-model="datatable.queryParams.filter.student_number" />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name" />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="datatable.queryParams.filter.surname" />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group :label="$t('psychologist')">
                            <multi-selectbox v-model="datatable.queryParams.filter.psychologist_id"
                                             :disabled="isAdmin"
                                             :multiple="false"
                                             :options="psychologistOptions"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group :label="$t('application_status')">
                            <parameter-selectbox
                                v-model="datatable.queryParams.filter.appointment_status"
                                code="psychologist_appointment_statuses"
                                :multiple="false"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group :label="$t('application_date')">
                            <select-date v-model="datatable.queryParams.filter.application_date" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="updateModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="clearModal">
                <template v-slot:CommonModalTitle>
                    {{ $t(modalTitle).toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <application-update v-if="id" :id="id" :mode="modalTitle" @updateTable="updateOnSuccess"  />
                </template>
            </CommonModal>
            <CommonModal ref="appointmentModal" size="xxl">
                <template v-slot:CommonModalTitle>
                    {{ $t('pcgc_appointment_schedule').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <appointment-timetable v-if="appointmentSwitch" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>

import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

//Components
import DatatableFilter from "@/components/datatable/DatatableFilter"
import Datatable from "@/components/datatable/Datatable"
import {ValidationObserver, ValidationProvider} from "vee-validate"
import CommonModal from "@/components/elements/CommonModal"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import SelectDate from "@/components/interactive-fields/SelectDate"
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox"

//Services
import PcgcService from "@/services/PcgcService"

//Other
import qs from "qs"

//Pages
import ApplicationUpdate from "@/modules/pcgc/pages/ApplicationUpdate"
import AppointmentTimetable from "./AppointmentTimetable"




export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
        ValidationProvider,
        ValidationObserver,
        MultiSelectbox,
        SelectDate,
        ApplicationUpdate,
        AppointmentTimetable,
        ParameterSelectbox
    },
    metaInfo() {
        return {
            title: this.$t("pcgc"),
        };
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("show"),
                                class: "ri-eye-line",
                                permission: "pdrmapplication_show",
                                callback: (row) => {
                                  this.openModal(row, 'show')
                                },
                            },
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "psychologistappointment_appprove",
                                callback: (row) => {
                                    this.openModal(row, 'edit')
                                },
                                show: (row) => {
                                    return row.application_status_code == 'requested' ? true : false
                                }
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                permission: "pdrmapplication_delete",
                                callback: (row) => {
                                    this.appointmentCancelation(row)
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("id"),
                        field: "id",
                        sortable: false,
                        hidden: true,
                    },

                    {
                        label: this.$t("student_number"),
                        field: "student_number",
                        sortable: false,
                    },
                    {
                        label: this.$t("name"),
                        field: "student_name",
                        sortable: false,
                    },
                    {
                        label: this.$t("surname"),
                        field: "student_surname",
                        sortable: false,
                    },
                    {
                        label: this.$t("pcgc_application_datetime"),
                        field: "application_date",
                        sortable: false,
                        formatFn: (row, field) => {
                            if(row) {
                                return row+' '+field.application_time.substring(0,5)
                            }
                        }
                    },
                    {
                        label: this.$t("pcgc_appointment_date"),
                        field: "appointment_date",
                        sortable: false,
                        formatFn: (row, field) => {
                            if(row){
                                return row+' '+field.appointment_time.substring(0,5)
                            }
                        }
                    },
                    {
                        label: this.$t("campus"),
                        field: "campus",
                        sortable: false,
                    },
                    {
                        label: this.$t("psychologist"),
                        field: "psychologist_name",
                        sortable: false,
                        formatFn: (row, field) => {
                            return row+' '+field.psychologist_surname
                        }
                    },
                    {
                        label: this.$t("application_status"),
                        field: this.getLocaleField('application_status'),
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },

            appStatusOptions: [
                {
                    value: 'pending',
                    text: this.$t('pending'),
                }
            ],
            id: null,
            modalTitle: null,
            appointmentSwitch: false,
            psychologistOptions: [],
            isAdmin: false,
        }
    },

    created() {
        this.getPsychologists()
        this.setPsychologist()
    },

    computed: {
        appointmentObj() {
            return {
                show: this.checkPermission('psychologistappointment_index'),
                emit: 'openAppointmentModal',
                title: this.$t('pcgc_appointment_schedule'),
                icon: 'ri-calendar-schedule-line'
            }
        },
    },

    methods: {
        filter() {
            this.datatable.queryParams.page = 1
            this.getRows()
        },
        filterClear() {
            this.datatable.queryParams.filter = {}
            this.getRows()
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage
            this.getRows()
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage
            this.datatable.queryParams.page = 1
            this.getRows()
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : ""
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            }

            PcgcService.getAllPcgcApplications(config).then(response => {
                this.datatable.rows = response.data.data
                this.datatable.total = response.data.pagination.total
            }).finally(() => {
                this.datatable.isLoading = false;
            })
        },

        openModal(row, mode) {
            this.id = row.id
            this.modalTitle = mode
            this.$refs.updateModal.$refs.commonModal.show()
        },

        clearModal() {
            this.id = null
        },

        openAppointmentModal(){
            this.appointmentSwitch = true
            this.$refs.appointmentModal.$refs.commonModal.show()
        },

        appointmentCancelation(data) {
            this.$swal.fire({
                title: this.$t('confirmation'),
                text: this.$t('pcgc_cancelation_info'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    PcgcService.cancelApplication(data.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.getRows()
                    }).catch((e) => {
                        this.showErrors(e, null)
                    })
                }
            })
        },

        getPsychologists() {
            PcgcService.getPsychologists().then(response => {
                response.data.data.forEach(item => {
                    this.psychologistOptions.push({
                        text: item.full_name,
                        value: item.psychologist_id,
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        setPsychologist() {
            this.$store.dispatch("auth/initUser");
            let userData = this.$store.getters['auth/getUser']
            if(userData.active_role.name == 'A') {
                this.isAdmin = false
            } else {
                this.datatable.queryParams.filter.psychologist_id = userData.id
                this.isAdmin = true
            }
        },

        updateOnSuccess(){
            this.clearModal()
            this.$refs.updateModal.$refs.commonModal.hide()
            this.getRows()
        }

    },
};
</script>

